import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSaleTags } from "redux/slices";
import useNewDay from "../../../hooks/useNewDay";
import { useWebStoreContext } from "contexts";

export const useSaleTagsPolling = () => {
	const dispatch = useDispatch();
	const { newDay } = useNewDay();
	const { authToken } = useWebStoreContext();

	useEffect(() => {
		if (!authToken?.value) {
			return;
		}

		dispatch(getSaleTags());
		const interval = setInterval(() => {
			dispatch(getSaleTags());
		}, 2 * 60 * 1000);
		return () => clearInterval(interval);
	}, [dispatch, authToken?.value]);

	useEffect(() => {
		if (!authToken?.value) {
			return;
		}

		if (newDay) {
			dispatch(getSaleTags());
		}
	}, [dispatch, authToken?.value, newDay]);
};

export default useSaleTagsPolling;
